import React from "react";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import MUIDataTable from "mui-datatables";

const useStyles = makeStyles(() => ({
  head: { textAlign: "center", fontSize: 12, fontWeight: 500 },
  headLeft: { textAlign: "left", fontSize: 12, fontWeight: 500 },
  center: { textAlign: "center" },
  left: { textAlign: "left" },
  title: { fontSize: 16, color: "#000" },
}));

const ByAreaDetailTableCommon = ({ data, areaLayerId }) => {
  const classes = useStyles();
  const showPrefectureColumn = areaLayerId !== "japan_1_l1";
  const columns = [
    {
      name: "#",
      options: { filter: false, sort: false, customBodyRender: (value) => <div className={classes.center}>{value}</div> },
    },
    {
      name: "エリア名",
      options: {
        filter: true,
        sort: false,
        customHeadLabelRender: () => <span className={classes.headLeft}>エリア名</span>,
        customBodyRender: (value) => <div className={classes.left} style={{ minWidth: 200 }}>{value}</div>,
      },
    },
    ...(showPrefectureColumn ? [{
      name: "都道府県",
      options: {
        filter: true,
        sort: false,
        customHeadLabelRender: () => <span className={classes.headLeft}>都道府県</span>,
        customBodyRender: (value) => <div className={classes.left}>{value}</div>,
      },
    }] : []),
    { name: "登録数", options: { filter: false, sort: true, customBodyRender: (value) => <div className={classes.center}>{value}</div> } },
    { name: "未撮影数", options: { filter: false, sort: true, customBodyRender: (value) => <div className={classes.center}>{value}</div> } },
    { name: "レビューOK撮影数", options: { filter: false, sort: true, customBodyRender: (value) => <div className={classes.center}>{value}</div> } },
    { name: "達成率(%)", options: { filter: false, sort: true, customBodyRender: (value) => <div className={classes.center}>{value}</div> } },
    { name: "撮影者数", options: { filter: false, sort: true, customBodyRender: (value) => <div className={classes.center}>{value}</div> } },
  ];
  const options = {
    selectableRows: "none",
    filterType: "checkbox",
    filter: true,
    pagination: true,
    search: true,
    print: false,
    download: true,
    viewColumns: false,
    sortOrder: {
      name: "レビューOK撮影数",
      direction: "desc",
    },
    downloadOptions: { filename: "エリア別撮影達成率データ.csv", filterOptions: { useDisplayedColumnsOnly: true, useDisplayedRowsOnly: true } },
    rowsPerPage: 200,
    rowsPerPageOptions: [100, 200],
    responsive: "standard",
    textLabels: {
      body: { noMatch: "データがありません。", toolTip: "" },
      toolbar: { search: "検索", viewColumns: "列の表示", downloadCsv: "CSVダウンロード", filterTable: "テーブルのフィルター" },
      viewColumns: { title: "表示する列", titleAria: "テーブルの列の表示/非表示" },
      pagination: { next: "次のページ", previous: "前のページ", rowsPerPage: "表示件数" },
      filter: { all: "全て", title: "フィルター", reset: "リセット" },
    },
  };

  return (
    <Grid container spacing={1}>
      <Grid item sm={12}>
        <MUIDataTable title={<span className={classes.title}>エリア別一覧</span>} data={data || []} columns={columns} options={options} />
      </Grid>
    </Grid>
  );
};

export default ByAreaDetailTableCommon;
